/**
 * SpreadsheetAdapter
 *
 * Thin adapter that wires the SpreadsheetEditor into the component registry.
 * Mirrors how TextEditorAdapter wraps TextEditor.
 */

import React from 'react';
import { SpreadsheetEditor } from './SpreadsheetEditor';

export const SpreadsheetAdapter: React.FC = () => {
  return <SpreadsheetEditor />;
};

